import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableRow,
  CircularProgress,
  Paper,
  Button,
} from "@mui/material";
import { AdminUsers } from "../../../services/jobService";
import {
  CustomTableContainer,
  CustomTableHead,
} from "../../../components/TableComponent";
import { useDispatch } from "react-redux";
import { showAppAlert } from "../../../store/reducers/appreducer";
import AdminDetailsDialog from "./AdminDetails";
import AdminInviteDialog from "./AdminInvite";

const CompanyUsers = () => {
  const dispatch = useDispatch();
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [adminDialogOpen, setAdminDialogOpen] = useState(false);
  const [inviteDialogOpen, setInviteDialogOpen] = useState(false);
  const [adminName, setAdminName] = useState("");

  const getUsers = async () => {
    try {
      setLoading(true);
      const response = await AdminUsers();
      setUsers(response.users);

      const adminUsers = response.users.filter((user) => user.is_admin);
      if (adminUsers.length > 0) {
        const admin = adminUsers[0];
        setAdminName(`${admin.firstName} ${admin.lastName}`);
      }

      setLoading(false);
    } catch (error) {
      console.error("Error fetching users:", error);
      dispatch(
        showAppAlert({
          show: true,
          alertType: "error",
          alertMessage: "Failed to fetch users. Please try again.",
        })
      );
      setLoading(false);
    }
  };

  useEffect(() => {
    getUsers();
  }, []);

  const handleAdminDialogClose = () => {
    setAdminDialogOpen(false);
    getUsers();
  };

  if (loading) {
    return (
      <Box
        sx={{
          height: "80vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <CircularProgress />
        <Typography variant="body1" mt={2}>
          Loading users...
        </Typography>
      </Box>
    );
  }

  return (
    <>
      <Box
        sx={{
          border: "1px solid rgba(0, 0, 0, 0.2)",
          borderRadius: "30px",
          background: "#FFFFFF",
          boxShadow: "6px 6px 54px 0px #0000000D",
          padding: "20px",
        }}
      >
        <Box
          p={2}
          display="flex"
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography
            variant="h5"
            gutterBottom
            sx={{
              fontFamily: "Montserrat",
              fontWeight: 700,
              color: "#202224",
              opacity: 0.8,
            }}
          >
            Company Users
          </Typography>
          <Box display="flex" gap={2}>
            <Button
              variant="contained"
              onClick={() => setAdminDialogOpen(true)}
            >
              Admin Details
            </Button>
            <Button
              variant="outlined"
              onClick={() => setInviteDialogOpen(true)}
            >
              Send Invite
            </Button>
          </Box>
        </Box>

        <Box
          sx={{
            borderRadius: "16px",
            border: "1px solid rgba(0, 0, 0, 0.2)",
            overflow: "hidden",
            backgroundColor: "#fff",
            margin: "4px 0",
          }}
        >
          <CustomTableContainer component={Paper}>
            <Table>
              <CustomTableHead>
                <TableRow>
                  <TableCell align="center">First Name</TableCell>
                  <TableCell align="center">Last Name</TableCell>
                  <TableCell align="center">Phone</TableCell>
                  <TableCell align="center">Email</TableCell>
                  <TableCell align="center">Gender</TableCell>
                  <TableCell align="center">Role</TableCell>
                </TableRow>
              </CustomTableHead>
              <TableBody>
                {users.length === 0 && (
                  <TableRow>
                    <TableCell colSpan={6} align="center">
                      No users found.
                    </TableCell>
                  </TableRow>
                )}
                {users.map((user) => (
                  <TableRow key={user.id}>
                    <TableCell align="center">
                      {user.first_name || "N/A"}
                    </TableCell>
                    <TableCell align="center">
                      {user.last_name || "N/A"}
                    </TableCell>
                    <TableCell align="center">{user.phone || "N/A"}</TableCell>
                    <TableCell align="center">{user.email || "N/A"}</TableCell>
                    <TableCell align="center">{user.gender || "N/A"}</TableCell>
                    <TableCell align="center">
                      {user.is_admin ? "Admin" : "User"}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </CustomTableContainer>
        </Box>
      </Box>
      <AdminDetailsDialog
        open={adminDialogOpen}
        onClose={handleAdminDialogClose}
        admin={{ name: adminName }}
      />
      <AdminInviteDialog
        open={inviteDialogOpen}
        onClose={() => setInviteDialogOpen(false)}
      />
    </>
  );
};

export default CompanyUsers;
